'use strict';

function emptyGuid() {
    const guid = "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx".replace(/x/g, '0');
    return guid;
}

export default emptyGuid;